<capra-toast class="progress-toast" type="processing">
  <h4 class="toast-header" data-test="header-text">Refresh in progress...</h4>
  <ul class="toast-text">
    <li data-test="first-list-item">Running all queries in the Report</li>
    <li data-test="second-list-item">Fetching data</li>
  </ul>
</capra-toast>
